import { SITE } from "../constants/site";

export function buildWhatsAppUrl(message) {
  const phone = SITE.whatsappNumber.replace(/\D/g, "");
  const text = encodeURIComponent(message);
  return `https://wa.me/${phone}?text=${text}`;
}

export function buildProductQuoteMessage(productName) {
  return `I am interested in ${productName}`;
}

export function buildCartQuoteMessage(items) {
  const list = items
    .map((item) => `${item.name} x${item.quantity}`)
    .join(", ");
  return `I am interested in the following products: ${list}`;
}
